import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {
  TransferAccountStep,
  simCardType,
  transferOption,
  errorTxt,
  MessageContent,
  DWHMessageText,
  DwhActionType,
  DWHStatus,
  SelectedPackageType,
} from './Constant/Constant';
import {dwhGeneralReport} from './Reports/dwhReports';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';
import {getSimTypeCode, getEsimTypeCode} from 'app/utilities/domain/simTypeConstants';

export const getOrganizationBanNumbers = createAsyncThunk(
  'TransferOrganizationAccount/getOrganizationBanNumbers',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      var result = await ProviderManager.getProviderData('getOrgBansTransferAccount', [data]);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        serverError: true,
      };
    }
  },
);
export const validateSimCardNumber = createAsyncThunk('TransferOrganizationAccount/validateSimCardNumber', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('ValidateSim', [data]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
    };
  }
});
export const niudNumberValidation = createAsyncThunk('TransferOrganizationAccount/niudNumberValidation', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('niudNumberValidation', [data]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
    };
  }
});

export const getPhoneNumbers = createAsyncThunk('choseNewOrExistingCellNum/getPhoneNumbers', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('getPhoneNumbers', ['3', '0']);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const GetDeliverySlotsByAdress = createAsyncThunk('TransferOrganizationAccount/GetDeliverySlotsByAdress', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('GetDeliverySlotsByAdress', [data.city, data.street, data.homeNum, false]);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getPriceSim = createAsyncThunk('TransferOrganizationAccount/getPriceSim', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    var orgId = thunkAPI.getState().portalsBlock.selectedHetPay;
    const result = await ProviderManager.getProviderData('getPriceSimBusiness', [orgId, 'BANLVLSR', 'C']);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());

    return error;
  }
});

export const getDeliverySimPrice = createAsyncThunk('TransferOrganizationAccount/getDeliverySimPrice', async (orgId, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getDeliverySimPrice', [orgId]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());

    return error;
  }
});
export const GetOrganizationPricePlan = createAsyncThunk('TransferOrganizationAccount/getOrganizationPricePlan', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    var state = thunkAPI.getState().TransferOrganizationAccount;
    var orgId = thunkAPI.getState().portalsBlock.selectedHetPay;
    const GetOrgPPreq = {
      orgId,
      ban: state.selectedBanNumber,
      simType: state.simCardType == simCardType.sim ? 0 : 1,
    };

    const result = await ProviderManager.getProviderData('GetOrganizationPricePlan', GetOrgPPreq);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

//create order
export const createOrgSimOrder = createAsyncThunk('TransferOrganizationAccount/CreateOrgSimOrder', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    var state = thunkAPI.getState().TransferOrganizationAccount;
    var delivery = state.deliveryInfo;
    var orgId = thunkAPI.getState().portalsBlock.selectedHetPay;
    const orgSimOrderReq = {
      baseReq: {
        orgId,
        subscriberNumber: state.selectedPhoneNumber,
        email: state.email,
        simType: state.simCardType == simCardType.sim ? 0 : 1,
        isNiudAction: state.selectedTransferOption == transferOption.niud,
        ban: state.selectedBanNumber,
      },
      deliveryInfo: {
        city: delivery.city,
        street: delivery.street,
        houseNum: delivery.houseNum,
        apartment: delivery.apartment,
        receiverFName: delivery.receiverFName,
        receiverLName: delivery.receiverLName,
        receiverPhone: delivery.receiverPhone,
        notes: delivery.notes,
        startDate: delivery.startDate,
        endDate: delivery.endDate,
        round: delivery.round,
        pickLocation: delivery.pickLocation,
      },
      simCount: state.simCardCount.count.count,
    };

    const result = await ProviderManager.getProviderData('createOrgSimOrder', orgSimOrderReq);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});
export const transferBussinessCustomer = createAsyncThunk(
  'TransferOrganizationAccount/transferBussinessCustomer',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      var state = thunkAPI.getState().TransferOrganizationAccount;
      var orgId = thunkAPI.getState().portalsBlock.selectedHetPay;
      var serviceFormState = thunkAPI.getState().serviceAccessForm.serviceForm;
      var isSim = state.simCardType == simCardType.sim;
      var serviceForm = {};
      Object.keys(serviceFormState).forEach((key) => {
        serviceForm[key] = serviceFormState[key] ? 'Y' : 'N';
      });
      function getProductId() {
        if (isSim) {
          return state.selectedPricePlan.transferBussinessCustomer.productId_SIM;
        } else {
          return state.selectedPricePlan.transferBussinessCustomer.productId_eSIM;
        }
      }
      function getComSeq() {
        if (isSim) {
          return state.selectedPricePlan.transferBussinessCustomer.combSeq_SIM;
        } else {
          return state.selectedPricePlan.transferBussinessCustomer.combSeq_eSIM;
        }
      }
      function getPackage() {
        if (isSim) {
          return state.selectedPricePlan.transferBussinessCustomer.package_SIM;
        } else {
          return state.selectedPricePlan.transferBussinessCustomer.package_eSIM;
        }
      }
      const transferOrgAccountReq = {
        baseReq: {
          orgId,
          subscriberNumber: state.selectedPhoneNumber,
          email: state.email,
          simType: isSim ? 0 : 1,
          isNiudAction: state.selectedTransferOption == transferOption.niud,
          ban: state.selectedBanNumber,
        },
        planCode:
          state.selectedPricePlanType == SelectedPackageType.org ? state.selectedPricePlan.plan_code : state.selectedPricePlan.offerID,
        combSeq: state.selectedPricePlanType == SelectedPackageType.org ? state.selectedPricePlan.comb_seq : getComSeq(),
        bpkey: state.selectedPricePlanType == SelectedPackageType.org ? state.selectedPricePlan.bpkey : '',
        productId: state.selectedPricePlanType == SelectedPackageType.org ? '' : getProductId(),
        selectedPricePlanType: state.selectedPricePlanType,
        package: state.selectedPricePlanType == SelectedPackageType.org ? state.selectedPricePlan.chg_pckg_code : getPackage(),
        platformType:
          state.selectedPricePlanType == SelectedPackageType.org
            ? state.selectedPricePlan.platform_type
            : state.simCardType == simCardType.eSim
              ? 'E'
              : 'S',
        simCardNumber: isSim ? state.simCardNumber.replace(/- | /g, '') : '',
        tempNiudNumber: state.tempNiudNumber,
        ...serviceForm,
      };
      const result = await ProviderManager.getProviderData('transferBussinessCustomer', transferOrgAccountReq);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);

export const blockTransferBusinessCustomer = createAsyncThunk(
  'TransferOrganizationAccount/transferBussinessCustomer',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      var state = thunkAPI.getState().TransferOrganizationAccount;
      let subPhoneNum = '';
      if (state.selectedTransferOption === 'niud') {
        subPhoneNum = state.tempNiudNumber;
      } else {
        subPhoneNum = state.selectedPhoneNumber;
      }
      const blockTransferReq = {
        ban: state.selectedBanNumber,
        subscriberNumber: subPhoneNum,
      };
      const result = await ProviderManager.getProviderData('blockTransferBusinessCustomer', blockTransferReq);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return error;
    }
  },
);

export const getEntityDetailsInfo = createAsyncThunk('ban/GetEntityDetailsSecure', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const {selectedTransferOption, tempNiudNumber, selectedPhoneNumber} = thunkAPI.getState().TransferOrganizationAccount;
    const subPhoneNum = selectedTransferOption === 'niud' ? tempNiudNumber : selectedPhoneNumber;
    const result = await ProviderManager.getProviderData('checkIfEntityDetailsRetrieved', [subPhoneNum]);
    return result.Body;
  } catch (error) {
    return null;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

const initialState = {
  currentStep: TransferAccountStep.TransferLine,
  hasSimCard: null,
  simCardType: simCardType.undefined,
  deviceSupportsEsim: false,
  simCardNumber: '89972020 - ',
  simCardCount: {count: 0, error: errorTxt.simCardCountEmpty},
  simCardNumberAccepted: null,
  selectedTransferOption: transferOption.undefined,
  banListForSelect: [],
  selectedBanNumber: '',
  currentPopUp: '',
  showPopup: false,
  epiData: '',
  serviceForm: {
    zotDownConInd: false,
    zotVoteInd: false,
    zotDonateInd: false,
    zotInfoInd: false,
    zotRecContInd: false,
    zcnDownConInd: false,
    zcnRecContInd: false,
    intlInd: false,
    premium0Ind: false,
    premium1Ind: false,
    gprsRoamInd: false,
    b144Ind: false,
  },
  serviceFormIsSign: false,
  phoneNumbersForSelect: [],
  phoneNumberRequest: 0,
  selectedPhoneNumber: '',
  numberForNiudForm: {value: '', error: ''},
  tempNiudNumber: '',
  email: '',
  deliveryInfo: {
    city: '',
    street: '',
    houseNum: '',
    apartment: '',
    receiverFName: '',
    receiverLName: '',
    receiverPhone: '',
    notes: '',
    startDate: '',
    endDate: '',
    round: '',
    pickLocation: '',
  },
  price: {
    simPrice: '',
    esimPrice: '',
    deliveryPrice: '',
  },
  generalMessage: null,
  pricePlan: [],
  selectedPricePlan: null,
  selectedPricePlanType: null,
  orderNum: '',
};

const TransferOrganizationAccountSlice = createSlice({
  name: 'TransferOrganizationAccount',
  initialState: initialState,

  reducers: {
    resetState: (state) => ({
      ...initialState,
      epiData: state.epiData,
    }),
    setCurrentStep: (state, action) => {
      window.scrollTo(0, 0);
      state.currentStep = action.payload;
      return state;
    },
    setHasSimCard: (state, action) => {
      state.hasSimCard = action.payload;
      if (action.payload == true) {
        state.simCardType = simCardType.sim;
      }
    },
    setSimCardType: (state, action) => {
      state.simCardType = action.payload;
    },
    removeSimCardNumberAccepted: (state, action) => {
      state.simCardNumberAccepted = null;
    },
    setDeviceSupportsEsim: (state, action) => {
      state.deviceSupportsEsim = action.payload;
    },
    setSelectedTransferOption: (state, action) => {
      state.selectedTransferOption = action.payload;
    },

    setShowPopUp: (state, action) => {
      if (!action.payload) {
        state.currentPopUp = '';
      }
      state.showPopup = action.payload;
      return state;
    },
    setCurrentPopUp: (state, action) => {
      state.showPopup = true;
      state.currentPopUp = action.payload;
      return state;
    },
    setEpiData: (state, action) => {
      state.epiData = action.payload;
    },
    setServiceForm: (state, action) => {
      const stringSet = new Set(action.payload);
      Object.keys(state.serviceForm).forEach((key) => {
        state.serviceForm[key] = stringSet.has(key);
      });
      state.serviceFormIsSign = true;
    },
    setSimCardNumber: (state, action) => {
      state.simCardNumber = action.payload;
    },
    setSimCardCount: (state, action) => {
      state.simCardCount.count = action.payload;
      if (!action.payload.count || parseInt(action.payload.count == 0)) {
        state.simCardCount.error = errorTxt.simCardCountEmpty;
      } else {
        if (parseInt(action.payload.count) > parseInt(state.epiData.maxSimCardsCount?.value)) {
          state.simCardCount.error = errorTxt.simCardMaxCount;
        } else {
          state.simCardCount.error = '';
        }
      }
    },
    setNumberForNuid: (state, action) => {
      state.numberForNiudForm.value = action.payload.value;
      state.numberForNiudForm.error = action.payload.error;
    },
    setSelectedBanNumber: (state, action) => {
      state.selectedBanNumber = action.payload;
    },
    setSelectedPhoneNumber: (state, action) => {
      state.selectedPhoneNumber = action.payload;
    },
    setSelectedPricePlan: (state, action) => {
      state.selectedPricePlan = action.payload.plan;
      state.selectedPricePlanType = action.payload.type;
    },
    setOrgAccountDetails: (state, action) => {
      Object.assign(state, action.payload);
      return state;
    },
    setDeliveryInfo: (state, action) => {
      state.deliveryInfo = action.payload;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    setGeneralMessage: (state, action) => {
      state.generalMessage = action.payload;
    },
  },
  extraReducers: {
    [getOrganizationBanNumbers.pending]: (state) => {
      state.banListForSelect = [];
    },
    [getOrganizationBanNumbers.fulfilled]: (state, action) => {
      if (action.payload?.length > 0) {
        const banList = [];
        action.payload.map((banData) => {
          let ban = {banNumber: banData.banNumber, orgName: banData.banBusinessName, segment: banData.banAccountType};
          banList.push(ban);
        });
        state.banListForSelect = banList;

        if (action.payload?.length == 1) {
          state.selectedBanNumber = action.payload[0].banNumber;
        }
      } else {
        state.generalMessage = MessageContent.NoBans;
        state.currentStep = TransferAccountStep.GeneralMessage;
      }
    },
    [validateSimCardNumber.pending]: (state) => {
      state.simCardNumberAccepted = null;
    },
    [validateSimCardNumber.fulfilled]: (state, action) => {
      if (action.payload.statusCode == '00') {
        state.simCardNumberAccepted = action.payload.boolean;
      }
    },
    [niudNumberValidation.fulfilled]: (state, action) => {
      state.selectedPhoneNumber = state.numberForNiudForm.value;
      if (action.payload.statusCode == '00') {
        state.tempNiudNumber = action.payload.param;
        state.currentStep = TransferAccountStep.PlanSelection;
      } else {
        switch (action.payload.statusCode) {
          case '122501':
            state.generalMessage = MessageContent.niudCellcom;
            break;
          case '122599':
            state.generalMessage = MessageContent.niudNumberError;
            break;
          case '002499':
            state.generalMessage = MessageContent.niudTempNumberError;
            break;
          case '002401':
            state.generalMessage = MessageContent.niudTempNumberNotFound;
            break;
          default:
            state.generalMessage = MessageContent.GeneralError;
            break;
        }
        state.currentStep = TransferAccountStep.GeneralMessage;
      }
    },
    [getPhoneNumbers.pending]: (state) => {
      state.selectedPhoneNumber = '';
    },
    [getPhoneNumbers.fulfilled]: (state, action) => {
      if (action.payload.regularPhoneNumbersList.length > 0) {
        state.phoneNumberRequest = state.phoneNumberRequest + 1;
        state.phoneNumbersForSelect = action.payload.regularPhoneNumbersList;
      }
    },
    [getPriceSim.fulfilled]: (state, action) => {
      state.price = {
        ...state.price,
        simPrice: action.payload?.[getSimTypeCode()],
        esimPrice: action.payload?.[getEsimTypeCode()],
      };
      return state;
    },
    [getDeliverySimPrice.fulfilled]: (state, action) => {
      state.price = { ...state.price, deliveryPrice: action.payload?.[getSimTypeCode()] };
      return state;
    },
    [GetOrganizationPricePlan.fulfilled]: (state, action) => {
      var pricePlan = action.payload.extra?.filter((plan) => plan.plan_code_details_arr !== null);
      const selectedBanSegment = state.banListForSelect.find((ban) => ban.banNumber == state.selectedBanNumber)?.segment;
      if (pricePlan?.length > 0 || (selectedBanSegment == 'M' && state.epiData.packagesList.expandedValue.length > 0)) {
        state.pricePlan = pricePlan;
        state.currentStep = TransferAccountStep.PlanSelection;
      } else {
        if (action.payload.Message == 'NO_PLANS_FOR_PLATFORM') {
          state.generalMessage = MessageContent.NoPlansForPlatform;
        } else state.generalMessage = MessageContent.PricePlanNotFound;
        state.currentStep = TransferAccountStep.GeneralMessage;
      }
      return state;
    },
    [GetOrganizationPricePlan.rejected]: (state, action) => {
      state.generalMessage = MessageContent.GeneralError;
      state.currentStep = TransferAccountStep.GeneralMessage;
      return state;
    },
    [transferBussinessCustomer.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        state.orderNum = action.payload.orderId;
        if (state.simCardType == simCardType.sim) {
          if (state.selectedTransferOption == transferOption.niud) {
            state.generalMessage = MessageContent.SimActivatedSucceeded;
          } else {
            state.generalMessage = MessageContent.NewLineActivationSucceeded;
          }
          state.currentStep = TransferAccountStep.GeneralMessage;
        } else {
          state.currentStep = TransferAccountStep.EsimSuccessPage;
        }
      } else {
        state.currentStep = TransferAccountStep.GeneralMessage;
        state.generalMessage = MessageContent.GeneralError;
      }
      return state;
    },
    [createOrgSimOrder.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        state.orderNum = action.payload.orderId;
        state.currentStep = TransferAccountStep.SimOrderSuccessPage;
        dwhGeneralReport({
          data: state,
          actionType: DwhActionType.SuccessScreenDeliveryRegularSIM,
          messageText: DWHMessageText.SuccessScreenDeliverySIM,
          status: DWHStatus.Completed,
        });
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = TransferAccountStep.GeneralMessage;
      }
      return state;
    },
  },
});

export const {
  resetState,
  setCurrentStep,
  setCurrentPopUp,
  setShowPopUp,
  setServiceForm,
  setEpiData,
  setHasSimCard,
  setSimCardType,
  setSelectedTransferOption,
  setSelectedBanNumber,
  setDeliveryInfo,
  saveToHistory,
  setOrgAccountDetails,
  setSimCardNumber,
  setSimCardCount,
  setNumberForNuid,
  setSelectedPhoneNumber,
  setDeviceSupportsEsim,
  removeSimCardNumberAccepted,
  setGeneralMessage,
  setSelectedPricePlan,
} = TransferOrganizationAccountSlice.actions;

export default TransferOrganizationAccountSlice.reducer;
